// extracted by mini-css-extract-plugin
module.exports = {"button":"PkD3RuEfay4hKjrD7-aE2"};